angular.module('app')
  .config([
    '$stateProvider',
    '$urlRouterProvider',
    'configurationProvider',
    '$httpProvider',
    '$locationProvider',
    'KeepaliveProvider',
    'IdleProvider',
    '$analyticsProvider',
    function(
      $stateProvider,
      $urlRouterProvider,
      $configurationProvider,
      $httpProvider,
      $locationProvider,
      $keepaliveProvider,
      $idleProvider,
      $analyticsProvider) {

    var partialPath = function(partial_name) {
      return ('/' + partial_name + '.html');
    };

    var partial = function($state, type, pane) {
      var template,
        leftPane = (pane === 'left'),
        templateRoot = (leftPane) ? ('/resources/info-pane/partials/' + type) : ('/resources/right-pane/partials/' + type),
        customPartial = $configurationProvider.getPartial(type, $state.pane);

      if (leftPane) {
        template = partialPath('show');
      } else {
        if (customPartial && typeof(customPartial) === 'string' && customPartial.length > 0) {
          templateRoot = '/resources/right-pane/partials';
          template = partialPath(customPartial);
        } else {
          template = partialPath($state.pane);
        }
      }
      return (templateRoot + template);
    };

    var sharedResolve = {
      getCustomer: ['$q', 'authentication', function($q, $authentication) {
        if($authentication.isValid()) {
          return $authentication.getCustomer() || $authentication.simulateLogin();
        } else {
          var errorObject = { code: 'NOT_AUTHENTICATED' };
          return $q.reject(errorObject);
        }
      }]
    };

    $urlRouterProvider.otherwise(function($injector, $location) {
      $injector.invoke([
        '$state',
        'authentication',
        'configuration',
        'dblUserAgent',
        'edxCustomerSettingsService',
        function(
          $state,
          authentication,
          configuration,
          dblUserAgent,
          edxCustomerSettingsService
        ){
          if (authentication.isLoggedIn()) {
            $location.url(authentication.getCustomerDefaultUrl());
            return;
          }

          authentication.ensureLogin().then(function (customer) {
            var url;

            if (!authentication.isGuardian(customer) &&
                !edxCustomerSettingsService.getHideFtue() &&
                !configuration.isTrue('application.FTUE.hide') &&
                !dblUserAgent.hasMobileWidth()) {
                  edxCustomerSettingsService.setAutoShowFtue(true);
            }

            url = authentication.getCustomerDefaultUrl();
            $location.url(url);
          });

        }]
      );
    });

    /**
     * Note on analytics:
     * viewLevel = state name or viewLevel param
     * view = pane or sub-pane param
     * value = url
     */
    $stateProvider
      .state('home', {
        url: "/home",
        templateUrl: '/resources/core/partials/reports.html',
        params: {
          pane: 'classrooms_landing_page'
        }
      })
      .state('view-classroom', {
        url: "/view-classroom",
        templateUrl: '/resources/core/partials/blank.html',
        params: {
          pane: 'view_classrooms_landing_page'
        }
      })
      .state('add-assignment', {
        url: "/add-assignment",
        templateUrl: '/resources/core/partials/blank.html',
        params: {
          pane: "add_assignments",
        }
      })
      .state('curriculum', {
        url: "/curriculum",
        templateUrl: '/resources/core/partials/reports.html',
        params: {
          pane: "curriculum_page",
        }
      })
      .state('lesson-transcript', {
        url: "/lesson-transcript/:lang",
        templateUrl: '/resources/core/partials/reports.html',
        params: {
          pane: "lesson_transcript_page",
        }
      })
      .state('word-problem-generator', {
        url: "/word-problem-generator",
        templateUrl: '/resources/core/partials/reports.html',
        params: {
          pane: "word-problem-generator_page",
        }
      })
      .state('curriculum-domain', {
        url: "/curriculum/domain/:domainId",
        templateUrl: '/resources/core/partials/reports.html',
        params: {
          pane: "curriculum_domain_page",
        }
      })
      .state('curriculum-standard', {
        url: "/curriculum/domain/:domainId/standard/:standardId",
        templateUrl: '/resources/core/partials/reports.html',
        params: {
          pane: "curriculum_standard_page",
        }
      })
      .state('student-standards', {
        url: "/reports/student-standards/student/:studentId",
        views: {
          '@': {
            templateUrl: '/resources/core/partials/reports.html',
          }
        },
        params: {
          pane: "student-standards",
          viewLevel: "report"
        }
      })
      .state('reports', {
        url: "/reports",
        templateUrl: '/resources/core/partials/reports.html',
        params: {
          pane: 'reports_landing_page'
        }
      })

      .state('settings', {
        url: "/settings",
        templateUrl: '/resources/core/partials/reports.html',
        params: {
          pane: 'settings_landing_page'
        }
      })
      .state('adminPreferences', {
        url: "/preferences",
        templateUrl: '/resources/core/partials/reports.html',
        params: {
          pane: 'admin_preferences_page'
        }
      })
      .state('teacherPreferences', {
        url: "/teacher-preferences",
        templateUrl: '/resources/core/partials/reports.html',
        params: {
          pane: 'teacher_preferences_page'
        }
      })
      .state('teacher-settings', {
        url: "/teacher-settings",
        templateUrl: '/resources/core/partials/reports.html',
        params: {
          pane: 'teacher_settings_page'
        }
      })
      .state('impact', {
        url: "/reports/impact",
        views: {
          '@': {
              templateUrl: '/resources/core/partials/blank.html',
           }
        },
        params: {
          pane: "impact",
          viewLevel: "report"
        }
      })
      .state('student-usage', {
        url: "/reports/student-usage",
        views: {
          '@': {
              templateUrl: '/resources/core/partials/blank.html',
           }
        },
        params: {
          pane: "student-usage",
          viewLevel: "report"
        }
      })
      .state('newDashboardUsage', {
        url: "/reports/newDashboardUsage",
        views: {
          '@': {
              templateUrl: '/resources/core/partials/blank.html',
           }
        },
        params: {
          pane: "dashboard-usage",
          viewLevel: "report"
        }
      })
      .state('predictive-insights', {
        url: "/reports/predictive-insights",
        views: {
          '@': {
              templateUrl: '/resources/core/partials/blank.html',
           }
        },
        params: {
          pane: "predictive-insights",
          viewLevel: "report"
        }
      })
      .state('api-key', {
        url: '/api-key',
        views: {
          '@': {
            templateUrl: '/resources/core/partials/blank.html',
          }
        },
        params: {
          pane: "api-key",
        }
      })
      .state('dpi', {
        url: "/reports/dpi",
        views: {
          '@': {
              templateUrl: '/resources/core/partials/blank.html',
           }
        },
        params: {
          pane: "dpi",
          viewLevel: "report"
        }
      })
      .state('standards-proficiency', {
        url: "/reports/standards-proficiency",
        views: {
          '@': {
              templateUrl: '/resources/core/partials/blank.html',
           }
        },
        params: {
          pane: "standards-proficiency",
          viewLevel: "report"
        }
      })
      .state('progress', {
        url: "/reports/progress",
        views: {
          '@': {
            templateUrl: '/resources/core/partials/blank.html',
          }
        },
        params: {
          pane: "progress",
          viewLevel: "report"
        }
      })
      .state('assignment-overview', {
        url: "/reports/assignment-overview",
        views: {
          '@': {
            templateUrl: '/resources/core/partials/blank.html',
          }
        },
        params: {
          pane: "assignment-overview",
          viewLevel: "report"
        }
      })
      .state('activity-feed', {
        url: "/reports/activity-feed",
        views: {
          '@': {
            templateUrl: '/resources/core/partials/blank.html',
          }
        },
        params: {
          pane: "activity-feed",
          viewLevel: "report"
        }
      })
      .state('proficiency-by-grade', {
        url: "/reports/proficiency-by-grade/classroom/:classroomId",
        views: {
          '@': {
            templateUrl: '/resources/core/partials/blank.html',
          }
        },
        params: {
          pane: "proficiency-by-grade",
          viewLevel: "report"
        }
      })
      .state('assignment-history-classroom', {
        url: "/reports/assignment-history/classroom/:classroomId",
        views: {
          '@': {
            templateUrl: '/resources/core/partials/blank.html',
          }
        },
        params: {
          pane: "assignments",
          viewLevel: "report"
        }
      })
      .state('assignment-history-student', {
        url: "/reports/assignment-history/classroom/:classroomId/student/:studentId",
        views: {
          '@': {
            templateUrl: '/resources/core/partials/blank.html',
          }
        },
        params: {
          pane: "assignments",
          viewLevel: "report"
        }
      })
      .state('student-proficiency-overview', {
        url: "/reports/student-proficiency-overview/student/:studentId",
        views: {
          '@': {
            templateUrl: '/resources/core/partials/blank.html',
          }
        },
        params: {
          pane: "student-proficiency-overview",
          viewLevel: "report"
        }
      })
      .state('retired-report-error', {
        url: "/retired-report-error",
        views: {
          '@': {
            templateUrl: '/resources/core/partials/reports.html',
          }
        },
        params: {
          pane: "retired-report",
        }
      })
      .state('missingroster', {
        url: "/missingroster",
        views: {
          '@': {
            templateUrl: '/resources/core/partials/reports.html'
          }
        },
        params: {
          pane: "missingroster"
        }
      })
      .state('report', {
        abstract: true,
        url: '/district',
        controller: 'EdxReportController',
        templateUrl: '/resources/core/partials/edx-report.component.html'
      })

      .state('district', {
        parent: 'report',
        url: '/:districtId?breadcrumbs&pane&order&sort&timeframe&timeframeId&by&seed&debug',
        params: {
          pane: 'schools',
          tracking: null
        },
        resolve: sharedResolve,
        data: {},
        views:
        {
          'rightPane': {
            controller: 'EdxDistrictReportController',
            templateUrl: function($state) {
              return partial($state, 'district', 'right');
            }
          }
        }
      })

    .state('grade', {
      parent: 'report',
      url: '/:districtId/grade/:gradeId?schoolId&breadcrumbs&pane&order&sort&timeframe&timeframeId&by&debug',
      params: {
        pane: function($state) {
          return ($state.params.schoolId !== undefined) ? 'teachers' : 'schools';
        },
        tracking:null
      },
      resolve: sharedResolve,
      data: {},
      views: {
        'leftPane': {
          templateUrl: function($state) {
            return partial($state, 'grade', 'left');
          }
        },
        'rightPane': {
          templateUrl: function($state) {
            return partial($state, 'grade', 'right');
          }
        }
      }
    })

    .state('school', {
      parent: 'report',
      url: '/:districtId/school/:schoolId?gradeId&breadcrumbs&pane&order&sort&timeframe&timeframeId&by&debug',
      params: {
        pane: 'teachers',
        tracking:null
      },
      resolve: sharedResolve,
      data: {},
      views: {
        'rightPane': {
          controller: 'EdxSchoolReportController',
          templateUrl: function($state) {
            return partial($state, 'school', 'right');
          }
        }
      }
    })

    .state('teacher', {
      parent: 'report',
      url: '/:districtId/teacher/:teacherId?gradeId&schoolId&breadcrumbs&pane&order&sort&timeframe&timeframeId&by&debug',
      params: {
        pane: 'classes',
        tracking: null
      },
      resolve: sharedResolve,
      data: {},
      views: {
        'rightPane': {
          controller: 'EdxTeacherReportController',
          templateUrl: function($state) {
            return partial($state, 'teacher', 'right');
          }
        }
      }
    })

    .state('classroom', {
      parent: 'report',
      url: '/:districtId/classroom/:classroomId?gradeId&schoolId&teacherId&breadcrumbs&pane&assign&order&sort&timeframe&timeframeId&domain&standards&standardProficiency&focusType&by&viewType&debug',
      params: {
        pane: 'students',
        tracking: null
      },
      resolve: sharedResolve,
      data: {},
      views: {
        'rightPane': {
          controller: 'EdxClassroomReportController',
          templateUrl: function($state) {
            return partial($state, 'classroom', 'right');
          }
        }
      }
    })

    .state('student', {
      parent: 'report',
      url: '/:districtId/student/:studentId?gradeId&schoolId&teacherId&classroomId&breadcrumbs&pane&assign&order&sort&timeframe&timeframeId&standards&focusType&by&untilNow&debug',
      params: {
        pane: 'overview',
        tracking: null
      },
      resolve: sharedResolve,
      data: {},
      views: {
        'rightPane': {
          controller: 'EdxStudentReportController',
          templateUrl: function($state) {
            return partial($state, 'student', 'right');
          }
        }
      }
    })

    .state('guardian', {
      parent: 'report',
      url: '/:districtId/guardian/:customerId?gradeId&schoolId&teacherId&classroomId&studentId&studentDistrictId&breadcrumbs&pane&assign&order&sort&timeframe&timeframeId&standards&focusType&by&untilNow&debug',
      params: {
        pane: 'overview',
        tracking: null
      },
      resolve: sharedResolve,
      data: {},
      views: {
        'leftPane': {
          templateUrl: function($state) {
            return partial($state, 'guardian', 'left');
          }
        },
        'rightPane': {
          templateUrl: function($state) {
            return partial($state, 'guardian', 'right');
          }
        }
      }
    })

    .state('myflexpd', {
        url: '/myflexpd',
        templateUrl: '/resources/components/pd/edx-pd.component.html'
    })

    .state('legacy-dbl-resources', {
        url: '/leagcy-dbl-resources',
        templateUrl: '/resources/components/edx-resources/edx-resources.component.html'
    })
      .state('dbl-resources', {
        url: '/dbl-resources',
        templateUrl: '/resources/core/partials/reports.html',
        params: {
          pane: 'resources_landing_page'
        }
      })

    .state('ftue', {
        url: '/getting-started',
        templateUrl: '/resources/components/ftue/edx-ftue-page.component.html'
    });

    $httpProvider.interceptors.push('httpRequestInterceptor');

    // use the HTML5 History API
    $locationProvider.html5Mode(true);

    // log user out after a period inactivity
    $idleProvider.autoResume('notIdle');
    // keep the user logged in on the server side
    $keepaliveProvider.interval(600); // in seconds
    $keepaliveProvider.http('/ping');

    // turn off angulartics automatic tracking.  We will call the pageTrack() method from dblAnalyticsProvider
    $analyticsProvider.settings.pageTracking.autoTrackVirtualPages = false;

  }]);
